import { DatePipe } from "@angular/common";
import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { Router, ActivatedRoute } from "@angular/router";
import { PreloaderService } from "@core";
import { DataService } from "@core/bootstrap/data.service";
import { AddStepUserComponent } from "@shared/components/add-step-user/add-step-user.component";
import { AlertService } from "@shared/components/alert/alert.service";
import { PreviewPdfComponent } from "@shared/components/preview-pdf/preview-pdf.component";
import { LanguagePipe } from "@shared/pipes/language.pipe";
import { SweetAlertService } from "@shared/services/sweet-alert.service";
import { DwsrService } from "../../FORM_PS_TR1/services/dwsr.service";

@Component({
	selector: "app-form-pq1-view",
	templateUrl: "./form-pq1-view.component.html",
	styleUrls: ["./form-pq1-view.component.scss"],
})
export class FormPq1ViewComponent implements OnInit {
	@Input() form_key;
	@Input() form_request_id;
	@Input() project_data;
	@Input() supervision_data;
	@Input() allData;
	viewMode: boolean = false;
	transaction_request: any;
	persons: any = [];
	notes: any = [];
	history: any = [];
	collectionSize: any;
	page = 1;
	pageSize = 10;
	form_url = "";
	form: FormGroup;
	lang_key = localStorage.getItem("lang_key");
	//stepper
	@ViewChild("stepper") myStepper: MatStepper;
	totalStepsCount: number = 6;
	selectedIndex: number = 0;
	stepProgressValue = 100 / this.totalStepsCount;
	progressValue = this.stepProgressValue;
	stepsTitles = [
		{
			label: `${this.lang.transform("lang_configurations")}`,
			value: "CONFIGURATION - GENERAL",
		},
		{
			label: `${this.lang.transform("lang_teams")}`,
			value: "CONFIGURATION - TEAMS",
		},
		{
			label: `${this.lang.transform("lang_terms_conditions")}`,
			value: "CONFIGURATION -CONDITIONS",
		},
		{
			label: `${this.lang.transform("lang_finicla_managers")}`,
			value: "FINICLA_MANAGERS_STEP",
		},
		{
			label: `${this.lang.transform("lang_executive_management")}`,
			value: "EXECUTIVE_MANAGEMENT",
		},
		{
			label: `${this.lang.transform("lang_final_result")}`,
			value: "Final_Result",
		},
	];
	stepTitle = this.stepsTitles[this.selectedIndex].label;
	@ViewChild("stepTitleEl", { static: false })
	stepTitleEl?: ElementRef<HTMLElement>;
	varSettimeout: any;
	isLinear: boolean = false;
	showStatus: boolean = false;
	@Output() showAction = new EventEmitter();
	Configurations_Attachments = [];
	All_Attachments = [];
	lastStepOpened = "";
	lastStepOpenedShow = "";
	usersTooltip = "";
	expandedStep = 0;
	rejected = null;
	Admin_Persons: boolean = false;
	configurationData;
	teamsData;
	termsData;
	constructor(
		public ds: DataService,
		public datepipe: DatePipe,
		private dwsrService: DwsrService,
		public lang: LanguagePipe,
		public spinner: PreloaderService,
		public alert: AlertService,
		public fb: FormBuilder,
		public router: Router,
		public dialog: MatDialog,
		public changeDetectorRef: ChangeDetectorRef,
		private sweetAlert: SweetAlertService,
		private activeRoute: ActivatedRoute
	) {
		this.activeRoute.params.subscribe((routeParams) => {
			this.form_request_id = routeParams?.form_request_id;
			this.form_key = routeParams?.form_key;
			this.dwsrService.form_request_id = routeParams?.form_request_id;
			this.dwsrService.form_key = routeParams?.form_key;
			this.refreshComponent(true, routeParams?.form_request_id);
		});
	}

	ngOnInit(): void {
		this.refreshLists();
	}

	getStepsHistory() {
		this.configurationData = {
			language:
				this.allData?.form_pq1_data?.records?.lang_key == "ar"
					? this.lang.transform("lang_arabic")
					: this.lang.transform("lang_english"),
			subject: this.allData?.form_pq1_data?.records?.subject,
			care: this.allData?.form_pq1_data?.records?.care,
			transaction_to: this.allData?.form_pq1_data?.records?.transaction_to,
			vat_name: this.allData?.form_pq1_data?.records?.vat_name,
			quotation_types_name:
				this.allData?.form_pq1_data?.records?.quotation_types_name,
			content: this.allData?.form_pq1_data?.records?.content,
			attachmentTitle: this.allData?.form_pq1_data?.records?.attachment,
		};
		this.teamsData = this.allData?.form_pq1_quotation_teams_request?.records;
		this.termsData = this.allData?.terms;
	}

	refreshComponent(e, form_request_id?) {
		if (e == true) {
			this.initViewForm(form_request_id);
			this.ngOnInit();
		}
	}

	initViewForm(form_request_id?) {
		this.form_url = "FORM_PQ1";
		this.spinner.show();
		this.dwsrService.getData(form_request_id).subscribe(
			(data) => {
				this.spinner.hide();
				if (data.status) {
					this.allData = data;
					this.Admin_Persons = data?.step_status?.buttons?.Admin_Persons;
					this.viewMode = data?.transactions_request?.records?.view_link
						? true
						: false;
					this.persons = data?.transactions_persons?.records || [];
					this.notes = data?.transactions_notes?.records || [];
					this.transaction_request = data?.transactions_request || {};
					this.history = data?.transactions_records.records || [];
					this.collectionSize = this.history.length;
					if (data?.Configurations_Attachments?.status) {
						this.Configurations_Attachments =
							data?.Configurations_Attachments?.records;
					}
					this.All_Attachments = this.Configurations_Attachments;
					this.lastStepOpened =
						data?.transactions_request?.transaction_request_last_step;
					this.selectedIndex = this.stepsTitles.findIndex((el) => {
						return el.value == this.lastStepOpened;
					});
					this.lastStepOpenedShow = this.stepsTitles[this.selectedIndex]?.label;
					if (this.lastStepOpened == "last") {
						this.selectedIndex = 5;
						this.lastStepOpenedShow = this.lang.transform("lang_last");
					} else if (this.lastStepOpened == "completed") {
						this.selectedIndex = 5;
						this.lastStepOpenedShow = this.lang.transform("lang_completed");
					}
					this.progressValue =
						this.stepProgressValue * (this.selectedIndex + 1);
					this.getLastOpenedUsers();
					this.getStepsHistory();
				} else {
					this.alert.error(data.error);
					this.router.navigate(["transactions/allforms"]);
				}
			},
			(err) => {
				this.spinner.hide();
				this.alert.error(err);
				this.router.navigate(["transactions/allforms"]);
			}
		);
	}

	getLastOpenedUsers() {
		let users = this.persons.filter((item) => {
			return item?.transactions_persons_action_status == "0";
		});
		let name = [];
		users.map((el) => {
			name.push(`${el?.person_name}`);
		});
		if (users[users.length - 1]?.transactions_persons_key4 == "REJECTED") {
			this.rejected = this.lang.transform("lang_rejected");
		} else {
			this.rejected = null;
		}
		name = name.filter(this.dwsrService.onlyUnique);
		this.usersTooltip =
			this.lang.transform("lang_users_access_open_step") + " : ";
		for (let i = 0; i < name.length; i++) {
			this.usersTooltip += name[i] + (i == name.length - 1 ? "" : " , ");
		}
	}

	addStepUser() {
		const dialogRef = this.dialog.open(AddStepUserComponent, {
			disableClose: false,
			width: "100%",
			data: {
				form_request_id: this.form_request_id,
				form_key: this.form_key,
			},
		});
	}
	scrollToElement() {
		let el = document.querySelector("#versions_section");
		el.scrollIntoView({ behavior: "smooth" });
	}

	openAccord(index) {
		this.expandedStep = index;
	}
	refreshLists() {
		this.history = this.history
			.map((list, i) => ({
				id: i + 1,
				...list,
			}))
			.slice(
				(this.page - 1) * this.pageSize,
				(this.page - 1) * this.pageSize + this.pageSize
			);
	}

	selectionChange(e: any) {
		this.selectedIndex = e.selectedIndex;
		this.progressValue = this.stepProgressValue * (this.selectedIndex + 1);
		this.stepTitle = this.stepsTitles[this.selectedIndex].label;
	}

	moveStepper(action: string) {
		if (
			action == "next" &&
			this.myStepper.selectedIndex + 1 < this.myStepper.steps.length
		) {
			this.myStepper.selectedIndex++;
		} else if (action == "prev" && this.myStepper.selectedIndex > 0) {
			this.myStepper.selectedIndex--;
		} else {
			return false;
		}
	}

	public preview_form_data(isView: boolean) {
		let url = "form/" + this.form_key + "/pr/" + this.form_request_id;
		if (isView) {
			url = this.transaction_request?.view_link;
		}
		this.spinner.show();
		this.ds.getActionByUrl([], url).subscribe(
			(res) => {
				this.spinner.hide();
				if (res.status) {
					if (res.extension == "pdf") {
						let src = "data:" + res["content-type"] + ";base64," + res.base64;
						const dialogRef = this.dialog.open(PreviewPdfComponent, {
							disableClose: false,
							width: "100%",
							data: {
								src: src,
								base64: res.base64,
							},
						});
					} else {
						this.sweetAlert.errorMessage("The attachment must be a PDF");
					}
				}
			},
			(err) => {
				this.spinner.hide();
				this.sweetAlert.errorToast(
					this.lang.transform("lang_internal_server_error"),
					2000
				);
			}
		);
	}

	ngOnDestroy(): void {
		clearTimeout(this.varSettimeout);
	}
}
